module.exports = "/lucky-balls/img/bigball/BigBall_015.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bigball/BigBall_015.png
// module id = 910
// module chunks = 0